export default {
  COMMAND: 'command',
  SUBSCRIBE: 'SubscribeCmd',
  REQUEST_SESSION: 'request_session',
  UNSUBSCRIBE: 'unsubscribe'
};
